import { useQuery } from "@tanstack/react-query";

import { ONE_SECOND_MS } from "#/config/time";

import { fetchBridgeStatus } from "../bridge.service";
import { RequestStatusEnum } from "../bridge.types";

export const useBridgeStatus = (requestHash: string) => {
  return useQuery({
    queryKey: ["fetchBridgeStatus", requestHash],
    queryFn: () => fetchBridgeStatus({ requestHash }),
    enabled: Boolean(requestHash),
    refetchInterval: (data) =>
      (data?.state.data?.bungeeStatusCode ?? -1) < RequestStatusEnum.FULFILLED
        ? ONE_SECOND_MS * 3
        : false,
  });
};
